import { useCallback } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import * as amplitude from "@amplitude/analytics-browser";
import * as userSelectors from "redux/user/selectors";
import { useSelector } from "react-redux";

export const useAnalytics = () => {
  const userId = useSelector(userSelectors.id);

  const trackEvent = useCallback(
    (eventType: string, eventProperties: Record<string, any> = {}) => {
      amplitude.track({
        // eslint-disable-next-line camelcase
        event_type: eventType,
        // eslint-disable-next-line camelcase
        event_properties: {
          ...eventProperties,
          userId,
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userId],
  );

  return {
    trackEvent,
  };
};
